<template>
  <div class="instagram-post-embed">
    <blockquote v-if="permalink" :key="permalink" class="instagram-media" :data-instgrm-permalink="permalink" data-instgrm-version="14">
      <a :href="permalink" target="_blank" rel="noopener noreferrer">View on Instagram</a>
    </blockquote>
  </div>
</template>

<script>
let embedScriptPromise

function loadInstagramScript () {
  if (window.instgrm && window.instgrm.Embeds) return Promise.resolve()
  if (embedScriptPromise) return embedScriptPromise
  embedScriptPromise = new Promise((resolve, reject) => {
    let script = document.querySelector('script[src="https://www.instagram.com/embed.js"], script[src="//www.instagram.com/embed.js"]')
    const existing = Boolean(script)
    if (!script) {
      script = document.createElement('script')
      script.src = 'https://www.instagram.com/embed.js'
      script.async = true
    }
    script.addEventListener('load', resolve, { once: true })
    script.addEventListener('error', reject, { once: true })
    if (!existing) document.head.appendChild(script)
  }).catch(error => {
    embedScriptPromise = null
    throw error
  })
  return embedScriptPromise
}

export default {
  props: { url: { type: String, default: '' } },
  computed: {
    permalink () {
      const match = this.url.trim().match(/^https?:\/\/(?:www\.)?instagram\.com\/(p|reel|reels|tv)\/([\w-]+)/i)
      if (!match) return ''
      const type = match[1].toLowerCase() === 'reels' ? 'reel' : match[1].toLowerCase()
      return `https://www.instagram.com/${type}/${match[2]}/`
    }
  },
  mounted () { this.processEmbed() },
  watch: { permalink () { this.processEmbed() } },
  methods: {
    async processEmbed () {
      if (!this.permalink) return
      try {
        await loadInstagramScript()
        await this.$nextTick()
        if (!this._isDestroyed && window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process()
      } catch (error) {
        // Keep the post link available when Instagram's script cannot load.
      }
    }
  }
}
</script>

<style scoped>
.instagram-post-embed {
  width: 100%;
  overflow: hidden;
}
.instagram-post-embed ::v-deep .instagram-media {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// InstagramPostEmbed.vue?d712a94e